import styles from '../shared/ShopSmartSelect.module.css';
import { useTranslation } from 'react-i18next';
import SmartSelectView from '../../smart-select/SmartSelect.view';
import type ShopSmartSelectProperties from './ShopSmartSelect.properties.ts';
import type { CSSProperties } from 'react';
import type { SelectType } from '../../shared/select/Select.type.ts';

export default function ShopSmartSelectView(props: ShopSmartSelectProperties) {
  const { t } = useTranslation();
  const marketName = props.marketsData?.at(0)?.name;

  return (
    <div className={styles.shopSmartSelectContainer}>
      <div>
        {props.marketsData && props.marketsData.length > 1 && (
          <SmartSelectView
            data={props.marketsData.map(
              (item) =>
                ({
                  value: item.id?.toString(),
                  label: item.name,
                }) as SelectType
            )}
            handleChange={props.handleChange}
            selectedValue={props.selectedValue}
            marginTop={props.isMobile ? 10 : 13}
            marginBottom={props.isMobile ? 10 : 0}
          />
        )}

        {props.marketsData && props.marketsData.length === 1 && marketName && (
          <div
            className={styles.shopContainer}
            style={
              {
                '--margin-top': props.isMobile ? 10 : 13,
                '--margin-bottom': props.isMobile ? 10 : 0,
              } as CSSProperties
            }
          >
            {marketName}
          </div>
        )}

        {(!props.marketsData || props.marketsData.length === 0) && (
          <div
            className={styles.shopContainer}
            style={
              {
                '--margin-top': props.isMobile ? 10 : 13,
                '--margin-bottom': props.isMobile ? 10 : 0,
              } as CSSProperties
            }
          >
            {t('ui.noMarketAvailable')}
          </div>
        )}
      </div>
    </div>
  );
}
